import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  formContainer: {
    paddingBottom: 20,
    paddingTop: 20,
  },
}));
